function isChunkText(chunk) {
  return chunk.type === 'text';
}
function isChunkString(chunk) {
  return chunk.type === 'string';
}
function isChunkTextOrString(chunk) {
  return chunk.type === 'text' || chunk.type === 'string';
}
function isKnownChunk(chunk, blocks) {
  return typeof chunk.type === 'string' && (typeof blocks[sanitizeBlockType(chunk.type)] === 'function' || ['image', 'file', 'image_url'].includes(chunk.type));
}
function sanitizeBlockType(type) {
  return type.replace(/Item$/, '');
}
const LLM_DEFAULT_MIME_TYPES = '.jpg, .jpeg, .png, .svg, .webp, .txt, .md, .pdf, .csv, .doc, .xls, .ppt';
const LLM_DEFAULT_MAX_FILE_SIZE = 1048576; // 1Mb
// export const LLM_DEFAULT_MAX_FILE_SIZE = 2097152; // 2Mb

export { LLM_DEFAULT_MAX_FILE_SIZE, LLM_DEFAULT_MIME_TYPES, isChunkString, isChunkText, isChunkTextOrString, isKnownChunk, sanitizeBlockType };
//# sourceMappingURL=types.js.map
